





























































import { Component, Vue } from 'vue-property-decorator';
import { clientsModule } from '@/store';
import ServiceLayout from './ServiceLayout.vue';

@Component({
  name: 'service-page',
  components: { ServiceLayout },
})
export default class ServicePage extends Vue {
  get client() {
    return clientsModule.model;
  }

  form = {
    title: '',
    stylistId: null,
    date: new Date().valueOf(),
    time: new Date().valueOf(),
    comment: '',
    story: {
      title: '',
      subtitle: '',
      imgSrc: '',
      theme: 'light',
    },
  }
}
